export enum ACCOUNT_IDENTITY {
  STUDENT = 'c3R1ZGVudA',
  INSTRUCTOR = 'aW5zdHJ1Y3Rvcg',
}

export enum ACCOUNT_TYPE_URL_INDEX {
  STUDENT = 0,
  AOD = 1,
  INSTRUCTOR = 2,
}
